import { createSlice } from '@reduxjs/toolkit'
import {
  getRoomTypes,
  getHotelConfigurations,
  addHotelConfiguration,
  editHotelConfiguration,
  removeHotelConfiguration,
  addRoomType,
} from './thunks'
import { resetDestinationStatus } from '../destinations/destinationSlice'

const initialState = {
  roomTypes: [],
  configurations: [],
  status: 'idle',
  error: null,
}

export const hotelConfigSlice = createSlice({
  name: 'hotelConfigurations',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Room Types
    builder.addCase(getRoomTypes.fulfilled, (state, action) => {
      state.roomTypes = action.payload
    })
    builder.addCase(addRoomType.fulfilled, (state, action) => {
      state.roomTypes.push(action.payload)
    })

    // Configurations
    builder.addCase(getHotelConfigurations.pending, (state) => {
      state.status = 'loading'
    })
    builder.addCase(getHotelConfigurations.fulfilled, (state, action) => {
      state.configurations = action.payload
      state.status = 'successful'
    })
    builder.addCase(getHotelConfigurations.rejected, (state, action) => {
      state.status = 'failed'
      state.error = action.error
    })
    builder.addCase(addHotelConfiguration.fulfilled, (state, action) => {
      state.configurations.push(action.payload)
    })
    builder.addCase(editHotelConfiguration.fulfilled, (state, action) => {
      const index = state.configurations.findIndex(c => c.id === action.payload.id)
      if (index !== -1) {
        state.configurations[index] = action.payload
      }
    })
    builder.addCase(removeHotelConfiguration.fulfilled, (state, action) => {
      state.configurations = state.configurations.filter(
        (c) => c.id !== action.payload
      )
    })
  },
})

// Export a thunk that invalidates destination cache after config changes
export const invalidateDestinationsCache = () => (dispatch) => {
  dispatch(resetDestinationStatus())
}

export default hotelConfigSlice.reducer
